import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../services/user/user.service';
import {FormBuilder} from '@angular/forms';
import {Clipboard} from '@angular/cdk/clipboard';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-mailings',
    templateUrl: './mailings.component.html',
    styleUrls: ['./mailings.component.scss', '../../../styles/component-custom-style.scss', '../../../styles/form-input.scss'],
    standalone: false
})
export class MailingsComponent implements OnInit {

  representativesButtonDisabled = true;
  exchangeMembersButtonDisabled = true;
  boardMembersButtonDisabled = true;
  earlyBirdsButtonDisabled = true;

  formGroup = this.fb.group({
    emailsRepresentatives: '',
    emailsExchangeMembers: '',
    emailsBoardMembers: '',
    emailsEarlyBirds: '',
  });

  constructor(private readonly fb: FormBuilder,
              public readonly translate: TranslateService,
              private readonly userService: UserService,
              private readonly clipboard: Clipboard,
              private readonly snackbar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    this.userService.getAllUsersMailings().subscribe(users => {
      const emailStringRepresentatives = users.filter(user => user.email != null && user.isRepresentative === true).map(obj => obj.email).join('; ');
      this.formGroup.patchValue({emailsRepresentatives: emailStringRepresentatives !== '' ? emailStringRepresentatives : this.translate.instant('mailings.noEmailFound')});
      if (emailStringRepresentatives !== '')
        this.representativesButtonDisabled = false;

      const emailStringBoardMembers = users.filter(user => user.email != null && user.isBoardMember === true).map(obj => obj.email).join('; ');
      this.formGroup.patchValue({emailsBoardMembers: emailStringBoardMembers !== '' ? emailStringBoardMembers : this.translate.instant('mailings.noEmailFound')});
      if (emailStringBoardMembers !== '')
        this.boardMembersButtonDisabled = false;

      const emailStringEarlyBirds = users.filter(user => user.email != null && user.isEarlyBird === true).map(obj => obj.email).join('; ');
      this.formGroup.patchValue({emailsEarlyBirds: emailStringEarlyBirds !== '' ? emailStringEarlyBirds : this.translate.instant('mailings.noEmailFound')});
      if (emailStringEarlyBirds !== '')
        this.earlyBirdsButtonDisabled = false;

      const emailStringExchangeMembers = users.filter(user => user.email != null &&
        (user.type === "ROLE_BROKER" || user.type === "ROLE_INSURER" || user.type === "ROLE_UNDERWRITER" || user.type === "ROLE_EXPERT")).map(obj => obj.email).join('; ');
      this.formGroup.patchValue({emailsExchangeMembers: emailStringExchangeMembers !== '' ? emailStringExchangeMembers : this.translate.instant('mailings.noEmailFound')});
      if (emailStringExchangeMembers !== '')
        this.exchangeMembersButtonDisabled = false;
    });
  }

  copyEmailsByCategory(category: string): void {
    let emailText = this.getUsersByCategory(category);
    if (emailText) {
      this.clipboard.copy(emailText);
      this.snackbar.open(this.translate.instant('mailings.snackbarCopySuccess'), '', {
        panelClass: ['success-snackbar', 'custom-snackbar'],
      })
    }
  }

  private getUsersByCategory(category: string) {
    let emailText;
    if (category === 'representatives') {
      emailText = this.formGroup.value.emailsRepresentatives;
    } else if (category === 'exchangeMembers') {
      emailText = this.formGroup.value.emailsExchangeMembers;
    } else if (category === 'boardMembers') {
      emailText = this.formGroup.value.emailsBoardMembers;
    } else if (category === 'earlyBirds') {
      emailText = this.formGroup.value.emailsEarlyBirds;
    }
    return emailText;
  }

  sendEmailByCategory(category: string): void {
    let emailText = this.getUsersByCategory(category);
    if (emailText) {
      window.open(`mailto:${emailText}`, '_self');

    }
  }

}
